import React from 'react';
import sql from '../../images/integrations/sql-database.svg';
import IntegrationBot from '../../components/integrationn/index';

const SQLDatabase = () => <IntegrationBot botLogo={sql} botName={'SQL Database'} />;

export default SQLDatabase;
